import * as React from 'react'
import styled from 'styled-components'
import { fontSizes } from '@src/styles/theme'
import { panelRadius } from '@components/panels/panels'
import { rgba } from 'polished'

const Grid = styled.div<any>`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
  margin-bottom: 24px;
`

const NavCard = styled.div<any>`
  background: ${(props: any) => props.theme.panelBack};
  border-radius: ${panelRadius};
  padding: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;

  &:hover {
    border-color: ${rgba('#CEDAE1', 0.2)};
    background: ${(props: any) => props.theme.tab ? props.theme.tab.hover : rgba('#FFF', 0.03)};
  }
`

const NavTitle = styled.div<any>`
  font-family: 'NunitoSansSemiBold';
  font-size: ${fontSizes.XXS};
  color: ${(props: any) => props.theme.white};
  margin-bottom: 6px;
`

const NavDesc = styled.div<any>`
  font-size: 13px;
  color: ${(props: any) => props.theme.listDesc || '#9CA6AD'};
  line-height: 1.4;
`

export interface QuickNavItem {
  title: string
  description: string
  onClick: () => void
}

interface QuickNavGridProps {
  items: QuickNavItem[]
}

export const QuickNavGrid: React.FC<QuickNavGridProps> = ({ items }) => {
  return (
    <Grid>
      {items.map((item, i) => (
        <NavCard key={i} onClick={item.onClick}>
          <NavTitle>{item.title}</NavTitle>
          <NavDesc>{item.description}</NavDesc>
        </NavCard>
      ))}
    </Grid>
  )
}
